import React from "react";

const ImageSortControls = ({
    sortFieldOptions = [],
    sortField = "",
    sortOrder = "desc",
    onSortFieldChange,
    onSortOrderChange,
    sortDisabled = false
}) => (
    <div className={`info-image-sort-bar${sortDisabled ? " is-disabled" : ""}`}>
        <span className="info-image-sort-label">Sort by</span>
        <div className="info-image-sort-field">
            <select
                className="info-image-sort-select"
                value={sortField}
                onChange={e => onSortFieldChange?.(e.target.value)}
                disabled={sortDisabled}
                aria-label="Sort field"
            >
                {sortFieldOptions.map(item => (
                    <option value={item.field} key={item.field}>
                        {item.label}
                    </option>
                ))}
            </select>
        </div>
        <div className="info-image-sort-order">
            <select
                className="info-image-sort-select info-image-sort-select--order"
                value={sortOrder}
                onChange={e => onSortOrderChange?.(e.target.value)}
                disabled={sortDisabled}
                aria-label="Sort order"
            >
                <option value="asc">ASC</option>
                <option value="desc">DESC</option>
            </select>
        </div>
    </div>
);

export default ImageSortControls;
